import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { DocumentExtractionModel } from '../Model/DocumentExraction.Model';
@Injectable({
  providedIn: 'root'
})
export class CourierPackageService {
  public headers = new HttpHeaders ({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  });
  public options = {
    headers: this.headers
  };
  constructor(private _http: HttpClient) { }
  getDocumentDetails() {
    return this._http.get<any>(environment.ApiUrl + 'CourierPkgEYMP/GetAllCourierPackageDetails' , {});
  }


  getDocumentFailureDetails(incomingDate:any){
    return this._http.get<any>(environment.ApiUrl + 'CourierPkgEYMP/GetAllCourierPackageFailureDetails?incomingDate=' + incomingDate , {});
  }


  getdocumentInfoById(id:number){
    return this._http.get<DocumentExtractionModel>(environment.ApiUrl + 'CourierPkgEYMP/GetDocumentExtractionInfoByID?id=' + id , {});
  }


  getDocumentSuccessInfo(incomingDate:any){
    return this._http.get<any>(environment.ApiUrl + 'CourierPkgEYMP/GetCourierPackageSuccessInfo?incomingDate=' + incomingDate , {});
  }

  getDocumentPendingDetails(incomingDate: any) {
    return this._http.get<any>(environment.ApiUrl + 'CourierPkgEYMP/GetAllCourierPackagePendingDetails?incomingDate=' + incomingDate, {});
  }
  SaveDocumentExtraction(documentExtractionData: any) {
    return this._http.post<any>(environment.ApiUrl + 'CourierPkgEYMP/SaveDocumentExtraction', documentExtractionData, {});
  }

}
